import Base from "../../base";
import SideMenu from "../SideMenu";
import LeftMenu from "../../../components/LeftMenu";
import Header from "../Header";
import axiosConfig from "../../../services/Axios";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import FieldError from "../../../components/ui/FieldError";
import RequiredField from "../../../components/ui/RequiredField";
import Button from "../../../components/ui/Button";
import { toast } from "react-toastify";
import SubCategoriesList from "./SubCategoriesList";
import Title from "../../../components/ui/Title";
import { faTags } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

function CategorieForm() {
  const { id } = useParams();
  const [categorie, setCategorie] = useState();
  const form = useForm();
  const { t } = useTranslation();

  const getCategorie = async (id) => {
    await axiosConfig
      .get(process.env.REACT_APP_API_URL + "/api/item_categories/" + id)
      .then((response) => {
        if (response?.status === 200 && response?.data) {
          setCategorie(response.data);
        }
      });
  };
  useEffect(() => {
    getCategorie(id);
  }, [id]);

  const onSubmitCategorie = async (data) => {
    try {
      await axiosConfig
        .patch(process.env.REACT_APP_API_URL + categorie["@id"], data, {
          headers: { "Content-Type": "application/merge-patch+json" },
        })
        .then((response) => {
          if (response?.status === 200 && response?.data) {
            setCategorie(response.data);
            toast.success(t("global.changes_saved"), {
              theme: "colored",
              hideProgressBar: true,
            });
          }
        });
    } catch (e) {
      if (e.response.status !== 200 && e.response.data?.violations) {
        e.response.data.violations.map((v) => {
          form.setError(v.propertyPath, {
            type: "manual",
            message: v.message,
          });
        });
      }
    }
  };

  return (
    <Base>
      <Header />
      <div className="py-16 container m-auto px-6 grid grid-cols-12">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2">
          <LeftMenu menu={SideMenu} />
        </div>
        <div className="lg:ml-6 text-sm mt-10 lg:mt-0 col-span-12 lg:col-span-9 xl:col-span-10">
          {categorie && (
            <>
              <div className="lg:p-8 lg:px-10 lg:bg-white rounded-lg">
                <Title
                  icon={faTags}
                  title={t("categories.label") + " : " + categorie.name}
                />

                <div className="">
                  <form onSubmit={form.handleSubmit(onSubmitCategorie)}>
                    <div className="">
                      <label>
                        {t("categories.name")} <RequiredField /> :
                      </label>

                      <div className="grid grid-cols-12 gap-3">
                        <input
                          {...form.register("name")}
                          name="name"
                          type="text"
                          className="col-span-10"
                          defaultValue={categorie.name}
                        />
                        <Button
                          className="btn btn-primary col-span-2"
                          isloading={form.formState.isSubmitting}
                        >
                          {t("global.update")}
                        </Button>
                      </div>
                      <FieldError error={form.formState?.errors?.name} />
                    </div>
                  </form>
                </div>
              </div>
              <SubCategoriesList
                categorie={categorie}
                setCategorie={setCategorie}
                getCategorie={getCategorie}
              />
            </>
          )}
        </div>
      </div>
    </Base>
  );
}

export default CategorieForm;
